(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product-quick-buy"] && !Shopify.designMode) return;
  try {
    /*
    The SparkLayer product card is an open shadow root, so page CSS cannot lay it out.
    We adopt a stylesheet into each row's card: the price drops under the title
    (the card's wrappers become display: contents so it joins the row grid), then the selects
    stack, then quantity with the rules note, then Add with the heart underneath. Selectors are
    structural because SparkLayer ships Tailwind utility classes with no part attributes.
    Re-check them if SparkLayer changes the card markup.
  */
  (function () {
    var CSS = 'div[data-qb-label] { flex-direction: row; align-items: center; gap: 8px; }' +
      'div[data-qb-label]::before { content: attr(data-qb-label); flex: 0 0 4.5em; font-size: 12px; line-height: 1.2; opacity: 0.7; }' +
      'div[data-qb-label] > select { flex: 1 1 0; }' +
      'link + div.flex.flex-col { display: contents; }' +
      'link + div.flex.flex-col > div:first-child { grid-column: 2; grid-row: 2; align-self: start; min-width: 0; }' +
      'link + div.flex.flex-col > div:nth-child(2) { grid-column: 1 / -1; grid-row: 3; margin-top: 10px; min-width: 0; }' +
      '@media (min-width: 768px) {' +
      'link + div.flex.flex-col > div:nth-child(2) { margin-top: 0; grid-column: 3; grid-row: 1 / 3; justify-self: end; align-self: center; flex: 0 0 auto; width: auto; flex-direction: row; align-items: flex-start; gap: 16px; }' +
      'link + div.flex.flex-col > div:nth-child(2) > div:nth-child(1) { flex: 0 0 240px; width: 240px; }' +
      'link + div.flex.flex-col > div:nth-child(2) > div:nth-child(2) { flex: 0 0 auto; width: auto; flex-direction: row; align-items: flex-start; gap: 16px; }' +
      'link + div.flex.flex-col > div:nth-child(2) > div:nth-child(2) > div:nth-child(1) { flex: 0 0 200px; width: 200px; }' +
      'link + div.flex.flex-col > div:nth-child(2) > div:nth-child(2) > div:nth-child(2) { flex: 0 0 180px; width: 180px; flex-direction: column; align-items: stretch; }' +
      'link + div.flex.flex-col > div:nth-child(2) > div:nth-child(2) > div:nth-child(2) > div:nth-child(2) { align-self: flex-end; }' +
      '}';
    var supported = 'adoptedStyleSheets' in Document.prototype && 'replaceSync' in CSSStyleSheet.prototype;

    // The variant selects carry their option name (Waist, Length) but SparkLayer shows no label.
    function labelSelects(root) {
      root.querySelectorAll('select[name]').forEach(function (select) {
        var wrap = select.parentElement;
        if (wrap && wrap.getAttribute('data-qb-label') !== select.name) {
          wrap.setAttribute('data-qb-label', select.name);
        }
      });
    }

    function patch(card, tries) {
      if (card.__qbPatched) { return; }
      if (card.shadowRoot) {
        var sheet = new CSSStyleSheet();
        sheet.replaceSync(CSS);
        card.shadowRoot.adoptedStyleSheets = card.shadowRoot.adoptedStyleSheets.concat(sheet);
        card.__qbPatched = true;
        labelSelects(card.shadowRoot);
        new MutationObserver(function () { labelSelects(card.shadowRoot); })
          .observe(card.shadowRoot, { childList: true, subtree: true });
      } else if (tries < 600) {
        requestAnimationFrame(function () { patch(card, tries + 1); });
      }
    }

    function scan(root) {
      root.querySelectorAll('.qb-row spark-product-card').forEach(function (card) { patch(card, 0); });
    }

    if (!supported) { return; }
    scan(document);
    new MutationObserver(function () { scan(document); }).observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-block"] && !Shopify.designMode) return;
  try {
    /*
    SparkLayer's product card shows its variant selects (Waist, Length) without labels. The card is an
    open shadow root, so we adopt a small stylesheet and tag each select's wrapper with its option name.
    Quick buy rows (.qb-row) are laid out and labelled by card-product-quick-buy, so they are skipped here.
    Selectors are structural; re-check them if SparkLayer changes the card markup.
  */
  (function () {
    if (!('adoptedStyleSheets' in Document.prototype) || !('replaceSync' in CSSStyleSheet.prototype)) { return; }
    var CSS = 'div[data-pb-label] { display: flex; flex-direction: column; gap: 4px; }' +
      'div[data-pb-label]::before { content: attr(data-pb-label); font-size: 12px; line-height: 1.2; opacity: 0.7; }';

    function labelSelects(root) {
      root.querySelectorAll('select[name]').forEach(function (select) {
        var wrap = select.parentElement;
        if (wrap && wrap.getAttribute('data-pb-label') !== select.name) {
          wrap.setAttribute('data-pb-label', select.name);
        }
      });
    }

    function patch(card, tries) {
      if (card.__pbPatched) { return; }
      if (card.shadowRoot) {
        var sheet = new CSSStyleSheet();
        sheet.replaceSync(CSS);
        card.shadowRoot.adoptedStyleSheets = card.shadowRoot.adoptedStyleSheets.concat(sheet);
        card.__pbPatched = true;
        labelSelects(card.shadowRoot);
        new MutationObserver(function () { labelSelects(card.shadowRoot); })
          .observe(card.shadowRoot, { childList: true, subtree: true });
      } else if (tries < 600) {
        requestAnimationFrame(function () { patch(card, tries + 1); });
      }
    }

    function scan(root) {
      root.querySelectorAll('spark-product-card').forEach(function (card) {
        if (!card.closest('.qb-row')) { patch(card, 0); }
      });
    }

    scan(document);
    new MutationObserver(function () { scan(document); }).observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
